/*
 * Copyright (c) 2026 Étienne FOLIO
 * Tous droits réservés.
 *
 * Ce fichier fait partie d'un logiciel propriétaire.
 * Toute reproduction, modification ou distribution, totale ou partielle,
 * de ce fichier est interdite sans l'autorisation écrite préalable
 * de l'auteur.
 */

export const buildAclRightKey = (resource, action) => {
  if (!resource || !action) {
    return '';
  }
  return `api.${resource}.${action}`;
};

export const getUserAclRightsSet = (user) => {
  const rights = Array.isArray(user?.acl_rights) ? user.acl_rights : [];
  return new Set(rights.filter((key) => typeof key === 'string' && key.trim()));
};

export const hasAcl = (user, rightKey) => {
  if (!rightKey) {
    return false;
  }
  return getUserAclRightsSet(user).has(rightKey);
};

export const hasAnyAcl = (user, rightKeys = []) =>
  rightKeys.some((rightKey) => hasAcl(user, rightKey));
